// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const CodeBlock: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      component="pre"
      sx={{ fontSize: 'body2.fontSize', overflowWrap: 'break-word', whiteSpace: 'wrap' }}
    >
      {children}
    </Box>
  );
};
